import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { Footer } from './nav/Footer';
import { NavMenu } from './NavMenu';
import ScrollToTopButton from './ScrollToTopButton';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div>
        <NavMenu />
        <Container>
          {this.props.children}
        </Container>
        <ScrollToTopButton />
        
        <Footer />
      </div>
    );
  }
}
